/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/laporan-simponi?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  download({}, payload) {
    const url = process.env.VUE_APP_API_URL + `/laporan-simponi/${payload.id}/download`;
    return url;
  },

  detail({}, payload) {
    const url = `/laporan-simponi/${payload}`;
    return http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/laporan-simponi`;
    return http.post(url, payload.params);
  },

  update({}, payload) {
    const url = `/laporan-simponi/${payload.id}`;
    return http.patch(url, payload.params);
  },

  delete({}, payload) {
    const url = `/laporan-simponi/${payload.id}`;
    return http.delete(url);
  },

  async getLokasi({}, payload) {
    const url = `/lokasi?${queryString(payload.params)}`;
    const resp = await http.get(url).then(({ data }) => data);

    return resp;
  },

  async getLoket({}, payload) {
    const url = `/loket?${queryString(payload.params)}`;
    const resp = await http.get(url).then(({ data }) => data);

    return resp;
  },
};
